export enum TrainingMemberType {
  Trainee = 0,
  Trainer = 1,
}

export type TrainingMemberTypeValues = (typeof TrainingMemberType)[keyof typeof TrainingMemberType];

export const TrainingMemberTypeKeys = {
  [TrainingMemberType.Trainer]: 'common:training-member-type.trainer',
  [TrainingMemberType.Trainee]: 'common:training-member-type.trainee',
} as const;

export interface TrainingEventUser {
  id: string;
  firstName: string;
  lastName: string;
  fullName?: string;
  userImageId?: string;
  email?: string;
  role?: unknown;
  sortOrder?: number | null;
  requiresAction?: boolean;
  formSectionId?: string | null;
  memberType: TrainingMemberTypeValues;
  addedAsIndividual?: boolean;
  tagIds?: string[];
  userId?: string;
}
